import React from "react";
import BounceLoader from "react-spinners/BounceLoader";
import classes from "./Loader.module.css";
const Loader = () => {
  return (
    <div className={classes.loader}>
      <BounceLoader color="#000" />
    </div>
  );
};

export default Loader;
